<template>
    <div
        class="merlin-image-node position-relative merlin-asset-border"
        :class="{
            'left': align == 'left', 
            'right': align == 'right', 
            'center': align == 'center',
            'behind': align == 'behind',
            'front': align == 'front',
            'topandbottom': align == 'topandbottom', 
            customClass
            }"
        :style="{
            width: width,
            float: align,
            left: leftPos
        }"
    >
        <span class="merlin-asset-warning merlin-asset-warning-small">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width /> Merlin Asset
        </span>

        <img
            :merlinid="merlinid"
            :src="src"
            :alt="alt"
            :credit="credit"
            :class="{
                'center_image': align == 'center',
                'left_image': align == 'left', 
                'right_image': align == 'right', 
                'behind_image': align == 'behind',
                'front_image': align == 'front',
                'topandbottom_image': align == 'topandbottom',
            }"
            tabindex="-1"
            @keydown.delete="deleteNode"
            @keydown.escape="deleteNode"
        />

        <div class="merlin-id"
            :class="{
                'center_data': align == 'center',
                'left_data': align == 'left', 
                'right_data': align == 'right', 
                'behind_data': align == 'behind',
                'front_data': align == 'front',
                'topandbottom_data': align == 'topandbottom',
            }"
        >
            <b>MID:</b> {{merlinid}}
            <span v-if="alt"> <b>ALT:</b> {{alt}} </span>
            <span v-if="credit"> <b>Credit:</b> {{credit}} </span>
            <span v-if="caption"> <b>Caption:</b> {{caption}} </span>
            <span v-if="description"> <b>Description:</b> {{description}} </span>
        </div>

        <span class="node-actions">
            <b-btn size="sm" variant="primary" class="edit" @click.prevent="edit">
                <font-awesome-icon :icon="['far', 'edit']" />
            </b-btn>
            <b-btn size="sm" variant="danger" @click.prevent="deleteNode">
                <font-awesome-icon :icon="['fad', 'trash']" />
            </b-btn>
        </span>

        <edit-merlin-image-modal
            v-model="show_edit_merlin_image_modal"
            :view="view"
            :image="image"
            @save="save"
            @hide="show_edit_merlin_image_modal = false"
        />
    </div>
</template>

<style lang="scss">
.editor-content.readonly {
    .merlin-image-node {
        pointer-events: none;
    }
}
</style>

<style lang="scss" scoped>
.merlin-image-node {
    display: inline-flex;
    min-height: 50px;

    img {
        // width: 100%;
        transition: ease .25s;
        margin-bottom: 1rem;
    }

    .caption {
        display: none;
    }

    .merlin-id {
        position: absolute;
        font-size: 80%;
        bottom: 1rem;
        left: 5px;
        background: white;
        opacity: 0.5;
        display: none;
    }

    .node-actions {
        position: absolute;
        display: none;
        top: 10px;
        left: 10px;
        z-index: 3;
        * + * {
            margin-left: .25rem;
        }
    }

    &.left {
        float: left;
        justify-content: flex-start;
        margin-right: 25px;
        .node-actions {
            left: 10px;
            right: auto;
        }
    }

    &.right {
        float: right;
        justify-content: flex-end;
        margin-left: 10px;
        .node-actions {
            left: auto;
            right: 10px;
        }
    }

    .center_image{
        position: absolute; 
        z-index:3;
    }

    .center_data{
        position: relative;
        top: 0px;
        width: 100%;
        z-index: 3;
    }

    .left_image{
        z-index: 3;
    }

    .right_image{
        z-index: 3;
    }    

    .behind{
        background-color: blue;
    }
    .behind_image{
        position: absolute; 
        top: 25px;
        z-index: 1;
    }
    .behind_data{
        position: relative;
        top: 0px;
        min-width: 100%;
        z-index: 3;
    }

    .front_image{
        position: absolute; 
        top: 50px;
        z-index: 3;
    }
    .front_data{
        position: relative;
        top: 25px;
        min-width: 100%;
        z-index: 3;
    }
    .topandbottom_image{
        position: relative; 
        z-index: 3;
    }
    .topandbottom_data{
        min-width: 100%;
        z-index: 3;
    }

    // &:focus {
    //     img {
    //         outline: -webkit-focus-ring-color auto 3px;
    //     }
    // }

    &:hover {
        img {
            filter: brightness(75%);
        }
        .node-actions {
            display: block;
        }
        .merlin-id{
            display: block;
        }
    }
}
</style>

<script>
import EditMerlinImageModal from '@/components/modals/tiptap/EditMerlinImageModal'

export default {
    name: 'MerlinImage',
    data: () => ({
        show_edit_merlin_image_modal: false
    }),
    props: ['node', 'updateAttrs', 'view', 'getPos', 'customClass'],
    components: {
        EditMerlinImageModal
    },
    computed: {
        merlinid: {
            get () {
                return this.node.attrs.merlinid
            },
            set (merlinid) {
                this.updateAttrs({
                    merlinid
                })
            }
        },
        src: {
            get () {
                return this.node.attrs.src
            },
            set (src) {
                // we cannot update `src` itself because `this.node.attrs` is immutable
                this.updateAttrs({
                    src
                })
            }
        },
        align: {
            get () {
                return this.node.attrs.align
            },
            set (align) {
                this.updateAttrs({
                    align
                })
            }
        },
        alt: {
            get () {
                return this.node.attrs.alt
            },
            set (alt) {
                this.updateAttrs({
                    alt
                })
            }
        },
        caption: {
            get () {
                if (this.node.attrs.caption) {
                    return this.node.attrs.caption
                } else {
                    return null
                }
            },
            set (caption) {
                this.updateAttrs({
                    caption
                })
            }
        },
        credit: {
            get () {
                if (this.node.attrs.credit) {
                    return this.node.attrs.credit
                } else {
                    return null
                }
            },
            set (credit) {
                this.updateAttrs({
                    credit
                })
            }
        },
        description: {
            get () {
                if (this.node.attrs.description) {
                    return this.node.attrs.description
                } else {
                    return null
                }
            },
            set (description) {
                this.updateAttrs({
                    description
                })
            }
        },
        width: {
            get () {
                if (this.node.attrs.width) {
                    return this.node.attrs.width
                } else {
                    return null
                }
            },
            set (width) {
                this.updateAttrs({
                    width
                })
            }
        },
        style: {
            get () {
                if (this.node.attrs.style) {
                    return this.node.attrs.style
                } else {
                    return null
                }
            },
            set (style) {
                this.updateAttrs({
                    style
                })
            }
        },
        image () {
            let image = {}

            if (this.src) {
                image.src = this.src
            }

            if (this.merlinid) {
                image.merlinid = this.merlinid
            }

            if (this.width) {
                image.width = this.width
            }

            if (this.align) {
                image.align = this.align
            }

            if (this.alt) {
                image.alt = this.alt
            }

            if (this.caption) {
                image.caption = this.caption
            }

            if (this.credit) {
                image.credit = this.credit
            }

            if (this.description) {
                image.description = this.description
            }

            return image
        },
        leftPos () {
            let leftPos = '';    
            if (this.node.attrs.align == 'behind' || this.node.attrs.align ==  'front' || this.node.attrs.align == 'center' || this.node.attrs.align == 'topandbottom') {
                let widthNum = parseFloat(this.node.attrs.width.replace('%', ''));
                leftPos = ((100 - widthNum) / 2 )+'%';    
            }
            return leftPos;
        },
    },
    methods: {
        edit () {
            this.show_edit_merlin_image_modal = true
        },
        save (width, align, caption, alt, credit, description, customClass) {
            if (width) {
                width = width + '%'
            }

            this.updateAttrs({
                width
            })

            this.updateAttrs({
                align
            })

            this.updateAttrs({
                caption
            })

            this.updateAttrs({
                alt
            })

            this.updateAttrs({
                credit
            })

            this.updateAttrs({
                description
            })

            this.updateAttrs({ 
                customClass 
            })

            this.show_edit_merlin_image_modal = false
        },
        deleteNode () {
            let tr = null
            let pos = this.getPos()

            if (this.view) {
                tr = this.view.state.tr
            }

            tr.delete(pos, pos + this.node.nodeSize)

            this.view.dispatch(tr)

            if (
                this.view &&
                this.view.dom
            ) {
                this.view.dom.focus()
            }
        }
    },
    mounted () {

    }
}
</script>
